import React, { ReactElement, useMemo, useState } from 'react';
import { classNames } from 'utils/css';
import { useOverflowScrolling } from 'hooks/useOverflowScrolling';
import { isIos } from 'utils/platform';
import styles from './Loading.module.scss';
import {
  IOS_LOADING_GIF_URL,
  ANDROID_LOADING_GIF_URL,
  TOP_BAR_HEIGHT,
  TAB_BAR_HEIGHT,
} from './Loading.constants';
import { TLoadingProps } from './Loading.types';
import { useInterval } from '../../hooks/useInterval';
import { getStatusBarSizes } from '../../utils/statusBar';

function Loading({
  fixed = false,
  className,
  tabLoading = false,
}: TLoadingProps): ReactElement {
  const [showLoading, setShowLoading] = useState(false);
  useOverflowScrolling(
    'div[data-testid="TabContent"],div[data-testid="ContentWrapper"]'
  );
  const { topStatusBarSize } = getStatusBarSizes();

  const style: React.CSSProperties = useMemo(() => {
    if (!tabLoading) return { top: 0 };
    const tabContent = document.getElementById('tab-content');

    return {
      top: tabContent
        ? tabContent.getBoundingClientRect().top + window.scrollY
        : TOP_BAR_HEIGHT + TAB_BAR_HEIGHT + topStatusBarSize,
    };
  }, [tabLoading]);

  const gifStyle: React.CSSProperties = useMemo(() => {
    if (!tabLoading) return {};

    return {
      marginBottom: (TOP_BAR_HEIGHT + TAB_BAR_HEIGHT + topStatusBarSize) * 2,
    };
  }, [tabLoading]);

  const loadingClasses = classNames(
    styles.wrapper,
    !isIos() && styles.whiteBg,
    fixed && styles.fixed,
    className
  );

  const loaderUrl = isIos() ? IOS_LOADING_GIF_URL : ANDROID_LOADING_GIF_URL;

  useInterval(() => {
    setShowLoading(true);
  }, 200);

  return (
    <>
      {showLoading && (
        <div className={loadingClasses} data-testid="Loading" style={style}>
          <img
            alt="loader-gif"
            src={loaderUrl}
            className={styles.loadingGif}
            style={gifStyle}
          />
        </div>
      )}
    </>
  );
}

export { Loading };
